import Vue from 'vue'
import { MapPin, Phone, Mail } from 'lucide-vue'

// Registrar los componentes globalmente
Vue.component('LucideMapPin', MapPin)
Vue.component('LucidePhone', Phone)
Vue.component('LucideMail', Mail)
